import ImageHelper from "../../Helpers/ImageHelper";

const PortfolioDataUiUx = [
  {
    title: "Furniture App Ui",
    caption: "UiUx Design",
    image: ImageHelper.UiUX22,
    fullWebSS: false,
    hasInnerPage: false,
    urlSuffix: "uiux22",
    // innerPageData: UiUxProjectPageData.UiUX22,
  },
  {
    title: "Fitness/Gym Website",
    caption: "UiUx Design",
    image: ImageHelper.UiUX23,
    fullWebSS: false,
    hasInnerPage: false,
    urlSuffix: "uiux23",
    // innerPageData: UiUxProjectPageData.UiUX23,
  },
  {
    title: "Motorbike Racing Website",
    caption: "UiUx Design",
    image: ImageHelper.UiUX24,
    fullWebSS: false,
    hasInnerPage: false,
    urlSuffix: "uiux24",
    // innerPageData: UiUxProjectPageData.UiUX24,
  },
  {
    title: "E-Commerce App",
    caption: "UiUx Design",
    image: ImageHelper.UiUX25,
    fullWebSS: false,
    hasInnerPage: false,
    urlSuffix: "uiux25",
    // innerPageData: UiUxProjectPageData.UiUX25,
  },
  {
    title: "Realest Portal",
    caption: "UiUx Design",
    image: ImageHelper.UiUX26,
    fullWebSS: false,
    hasInnerPage: false,
    urlSuffix: "uiux26",
    // innerPageData: UiUxProjectPageData.UiUX26,
  },
  {
    title: "Heavenly E-Commerce",
    caption: "UiUx Design",
    image: ImageHelper.UiUX27,
    fullWebSS: false,
    hasInnerPage: false,
    urlSuffix: "uiux27",
    // innerPageData: UiUxProjectPageData.UiUX27,
  },
  // {
  //   title: "Food Delivery App",
  //   caption: "UiUx Design",
  //   image: ImageHelper.EatExpress,
  //   fullWebSS: false,
  //   hasInnerPage: true,
  //   urlSuffix: "uiux10",
  //   innerPageData: UiUxProjectPageData.uiux10,
  // },
  {
    title: "CasualChic- Casual Wear Store",
    caption: "UiUx Design",
    image: ImageHelper.CasualChic,
    fullWebSS: false,
    hasInnerPage: false,
    urlSuffix: "uiux10",
  },
  {
    title: "PropertyZone Landing Page",
    caption: "UiUx Design",
    image: ImageHelper.PropertyZoneLandingPageCover,
    fullWebSS: false,
    hasInnerPage: true,
    urlSuffix: "uiux11",
  },
  {
    title: "King Graphics Homepage",
    caption: "UiUx Design",
    image: ImageHelper.KingGraphicsTask4,
    fullWebSS: false,
    hasInnerPage: true,
    urlSuffix: "uiux12",
  },
  {
    title: "Bidroid Old Ui",
    caption: "App Ui",
    image: ImageHelper.BidroidOldUI,
    fullWebSS: false,
    hasInnerPage: false,
    urlSuffix: "uiux01",
  },
  {
    title: "Bidroid New Ui",
    caption: "App Ui",
    image: ImageHelper.BidroidNewUI,
    fullWebSS: false,
    hasInnerPage: false,
    urlSuffix: "uiux02",
  },
  {
    title: "CricBuzz App Ui",
    caption: "App Ui",
    image: ImageHelper.CricBuzzUI,
    fullWebSS: false,
    hasInnerPage: false,
    urlSuffix: "uiux03",
  },
  {
    title: "Soy Hill Candle Co.",
    caption: "Prototype",
    image: ImageHelper.SoyHill1,
    fullWebSS: true,
    hasInnerPage: false,
    urlSuffix: "uiux04",
  },
  {
    title: "Soy Hill Candle Co.",
    caption: "Prototype",
    image: ImageHelper.SoyHill2,
    fullWebSS: true,
    hasInnerPage: false,
    urlSuffix: "uiux05",
  },
  {
    title: "Soy Hill Candle Co.",
    caption: "Prototype",
    image: ImageHelper.SoyHill3,
    fullWebSS: true,
    hasInnerPage: false,
    urlSuffix: "uiux06",
  },
  {
    title: "Bidroid App",
    caption: "UiUx Design",
    image: ImageHelper.BidroidAppBanner,
    fullWebSS: false,
    hasInnerPage: true,
    urlSuffix: "uiux07",
  },
  {
    title: "Tabrez Dal - Expert Product Designer",
    caption: "Design",
    image: ImageHelper.TabrezDalExpertProductDesignerCover,
    fullWebSS: false,
    hasInnerPage: true,
    urlSuffix: "uiux08",
  },
  {
    title: "LinkedUp",
    caption: "UiUx Design",
    image: ImageHelper.LinkedupAppUiDesign,
    fullWebSS: false,
    hasInnerPage: true,
    urlSuffix: "uiux09",
  },
  {
    title: "moneyHop Registration Flow Design",
    caption: "UiUx Design",
    image: ImageHelper.HopRegistrationFlowDesign,
    fullWebSS: false,
    hasInnerPage: true,
    urlSuffix: "uiux13",
  },
  {
    title: "Rush Invoice App",
    caption: "UiUx Design",
    image: ImageHelper.RushInvoiceAppCover,
    fullWebSS: false,
    hasInnerPage: true,
    urlSuffix: "uiux14",
  },
  {
    title: "SOS Manager App Single Screen",
    caption: "UiUx Design",
    image: ImageHelper.SOSEmergencyAppCover,
    fullWebSS: false,
    hasInnerPage: true,
    urlSuffix: "uiux15",
  },
];

export default PortfolioDataUiUx;
